import classnames from 'tailwindcss-classnames';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export const MissingDataSourceText = 'Component is missing Data Source';

export type EditingHelpTextProps = {
  text: string;
  block?: boolean;
};

const EditingHelpText = ({ text, block }: EditingHelpTextProps): JSX.Element => {
  const isExperienceEditor = useExperienceEditor();

  return isExperienceEditor ? (
    <span
      className={classnames(
        block ? 'block' : 'inline-block',
        'mb-2',
        'ee-help-text-highlight',
        'text-sm'
      )}
      data-testid="editing-help-text"
    >
      <strong>{text}</strong>
    </span>
  ) : (
    <></>
  );
};

export const MissingDataSource = (): JSX.Element => (
  <EditingHelpText text={MissingDataSourceText} block />
);

export default EditingHelpText;
